// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import store from '@/store'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import './router/permission'
import 'lib-flexible/flexible.js'
import '@/assets/scss/reset.scss'
import VueLazyLoad from 'vue-lazyload'
import vueToTop from 'vue-totop'
import '@/icons'
import commonComponent from './common-components'
Vue.use(commonComponent)
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(VueLazyLoad)
Vue.use(vueToTop)
Vue.prototype.$popBox = MintUI
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js